var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable } from 'inversify';
import { BaseManagementService } from '@/services/base-management-service';
var MaterialService = /** @class */ (function (_super) {
    __extends(MaterialService, _super);
    function MaterialService() {
        var _this = _super.call(this, '/api/v1/management/material') || this;
        _this.materialPrefix = 'MM_';
        _this.materialTypePrefix = 'MT_';
        _this.materialGroupPrefix = 'MG_';
        return _this;
    }
    MaterialService.prototype.getValidationRules = function () {
        return {
            materialId: {
                required: true,
                min: 4,
                max: 4,
                isUniqueMaterialId: true,
            },
            materialName: {
                required: true,
                max: 10,
                regex: '^[^<>]+$',
            },
            materialDesc: {
                required: true,
                max: 100,
                regex: '^[^<>]+$',
            },
            materialTypeId: {
                required: true,
            },
            materialGroupId: {
                required: true,
            },
            notes: {
                max: 500,
            },
        };
    };
    MaterialService.prototype.getDefault = function () {
        return {
            materialId: null,
            materialName: '',
            materialDesc: '',
            materialTypeId: '',
            materialTypeDesc: '',
            materialGroupId: '',
            materialGroupDesc: '',
            notes: '',
            status: 'A',
            createdId: '',
            createdDate: '',
            modId: '',
            modDate: '',
            isDeleted: false,
        };
    };
    MaterialService.prototype.getAll = function (includeDeleted) {
        if (includeDeleted === void 0) { includeDeleted = true; }
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getall';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                IncludeDeleted: includeDeleted,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get materials');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Unable to get materials');
                        console.error(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MaterialService.prototype.getBySiteMaterialGroup = function (siteId, materialGroupId) {
        if (materialGroupId === void 0) { materialGroupId = 'D'; }
        return __awaiter(this, void 0, Promise, function () {
            var url, response, responseMessage, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = '/getbysitematerialgroup';
                        return [4 /*yield*/, _super.prototype.post.call(this, url, { SiteId: siteId, MaterialGroupId: materialGroupId })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get materials');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Unable to get materials");
                        console.error(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MaterialService.prototype.unFlattenMaterialsCollection = function (materials) {
        var _this = this;
        var flattenedMaterials = {};
        // add the materials
        flattenedMaterials.materials = materials
            .filter(function (item) { return item.startsWith(_this.materialPrefix); })
            .map(function (item) { return item.replace(_this.materialPrefix, ''); })
            .filter(function (item) { return item !== '0'; });
        // add the material types
        flattenedMaterials.materialTypes = materials
            .filter(function (item) { return item.startsWith(_this.materialTypePrefix); })
            .map(function (item) { return item.replace(_this.materialTypePrefix, ''); })
            .filter(function (item) { return item !== '0'; });
        // add the material groups
        flattenedMaterials.materialGroups = materials
            .filter(function (item) { return item.startsWith(_this.materialGroupPrefix); })
            .map(function (item) { return item.replace(_this.materialGroupPrefix, ''); })
            .filter(function (item) { return item !== '0'; });
        return flattenedMaterials;
    };
    MaterialService.prototype.restore = function (unFlattenedMaterial) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/restore';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                MaterialGroupId: unFlattenedMaterial.materialGroups[0],
                                MaterialTypeId: unFlattenedMaterial.materialTypes[0],
                                MaterialId: unFlattenedMaterial.materials[0],
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error("Unable to restore material");
                        console.error(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MaterialService.prototype.doesMaterialIdExist = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var url, request, response, responseMessage, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'doesmaterialidexist';
                        request = { MaterialId: item.materialId };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error('Unable to check if material id is a duplicate');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error('Unable to check if material id is a duplicate');
                        console.error(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MaterialService.prototype, "canViewType", {
        get: function () {
            return _super.prototype.canViewPage.call(this, 'MATERIALMGMT');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MaterialService.prototype, "canEditTypes", {
        get: function () {
            return _super.prototype.canEditPage.call(this, 'MATERIALMGMT');
        },
        enumerable: false,
        configurable: true
    });
    MaterialService.prototype.canRestoreItem = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve(true)];
            });
        });
    };
    MaterialService.prototype.canDeleteItem = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/candelete';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { MaterialId: item.materialId })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        console.error("Unable to check if material can be deleted");
                        console.error(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MaterialService.prototype, "canViewMaterialGroups", {
        get: function () {
            return this.canViewPage('MATERIALGRPMGMT');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MaterialService.prototype, "canViewMaterialTypes", {
        get: function () {
            return this.canViewPage('MATERIALTYPEMGMT');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MaterialService.prototype, "canViewSourcingSyn", {
        get: function () {
            return this.canViewPage('MATERIALMGMT#SOURCING');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MaterialService.prototype, "canEditSourcingSyn", {
        get: function () {
            return this.canEditPage('MATERIALMGMT#SOURCING');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MaterialService.prototype, "canViewBolSyn", {
        get: function () {
            return this.canViewPage('MATERIALMGMT#BOL');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MaterialService.prototype, "canEditBolSyn", {
        get: function () {
            return this.canEditPage('MATERIALMGMT#BOL');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MaterialService.prototype, "canViewSapSyn", {
        get: function () {
            return this.canViewPage('MATERIALMGMT#SAP');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MaterialService.prototype, "canEditSapSyn", {
        get: function () {
            return this.canEditPage('MATERIALMGMT#SAP');
        },
        enumerable: false,
        configurable: true
    });
    MaterialService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], MaterialService);
    return MaterialService;
}(BaseManagementService));
export { MaterialService };
